// Igor, la mascota (componentes/igor.tsx), sus consejos (componentes/consejos.ts) y el menú corto con el asistente.
export default {
  'Ver un consejo de Igor': 'See a tip from Igor',
  'Un consejo de Igor': 'A tip from Igor',
  'Consejo de Igor': 'Tip from Igor',
  'Otro consejo': 'Another tip',
  Entendido: 'Got it',
  // pantallas/paso.tsx y pasos/inicio.tsx (asistente)
  'Pasos de {seccion}': '{seccion} steps',
  'Paso {n} de {total}': 'Step {n} of {total}',
  '¡Tu marca está lista!': 'Your brand is ready!',
  '¡Tu mes está listo!': 'Your month is ready!',
  'Ya te conozco. Ahora armemos tu mes.': "Now I know you. Let's build your month.",
  'Tu mes está hecho. Solo falta decir cuándo sale.': 'Your month is done. Just choose when it goes out.',
  'Armar mi mes': 'Build my month',
  'Programar mi mes': 'Schedule my month',
  'Está bien, siguiente': 'Looks good, next',
  'Lo que sigue': "What's next",
  'Vamos paso a paso: yo te voy diciendo qué hacer y tú solo revisas.': "We'll go step by step: I tell you what to do and you just review.",
  Seguir: 'Continue',

  // negocio
  'Cuéntame a quién le vendes como se lo explicarías a un amigo. Entre más concreto, mejores posts te hago.':
    'Tell me who you sell to the way you would explain it to a friend. The more specific, the better your posts.',
  '¿Qué te hace distinto? Piensa en lo que tus clientes te dicen cuando te recomiendan.':
    'What makes you different? Think about what your customers say when they recommend you.',
  'Si tienes Instagram o página web, pónmelos: los leo y te ahorro preguntas.':
    'If you have Instagram or a website, add them: I read them and save you some questions.',
  // estrategia
  'No tienes que leerla toda hoy. Mira los temas: si alguno no va con tu negocio, pídeme cambiarlo.':
    "You don't have to read it all today. Look at the topics: if one doesn't fit your business, ask me to change it.",
  'Las frases de ejemplo están escritas como hablan tus clientes. Si alguna te suena rara, dímelo.':
    'The example lines are written the way your customers talk. If one sounds off, tell me.',
  'Pocas publicaciones venden directo: la mayoría enseñan o acompañan. Así la gente confía antes de comprar.':
    'Few posts sell directly: most teach or keep people company. That is how people come to trust you before they buy.',
  // redes
  'No te asustes con los números: son tu punto de partida y desde aquí medimos cuánto mejoras.':
    "Don't worry about the numbers: they are your starting point, and we measure your progress from here.",
  'Fíjate en el formato que mejor te funciona: te lo señalo para que hagamos más de eso.':
    'Look at the format that works best for you: I point it out so we can do more of it.',
  'Puedes conectar más de una red: así veo dónde te está yendo mejor.':
    'You can connect more than one network: that way I can see where you are doing best.',
  // identidad
  'Sube 3 publicaciones que te encanten, aunque no sean tuyas. Así aprendo tu estilo.':
    "Upload 3 posts you love, even if they aren't yours. That's how I learn your style.",
  'Si tienes logo en fondo claro y en fondo oscuro, sube los dos: se verá bien en cualquier diseño.':
    'If you have a logo for light and for dark backgrounds, upload both: it will look good on any design.',
  '¿Tus colores son exactos? Escríbelos y los uso tal cual en todos tus diseños.':
    'Do you have exact brand colors? Type them in and I will use them as they are in every design.',
  // presentador
  'Elige a quien se parezca a tus clientes: la gente confía en quien se le parece.':
    'Pick someone who looks like your customers: people trust those who resemble them.',
  'Puedes tener más de una persona y cambiar quién sale en cada video.':
    'You can have more than one person and change who appears in each video.',
  'Si quieres salir tú, sube una foto tuya con buena luz, de frente y sin gafas de sol.':
    'If you want to appear yourself, upload a well-lit photo of you, facing the camera and without sunglasses.',
  // mes
  'Con 3 publicaciones por semana basta: la constancia vale más que la cantidad.':
    'Three posts a week is enough: consistency beats quantity.',
  '¿Ese día no te sirve? Puedes mover la publicación a otro sin rehacer el plan.':
    "That day doesn't work for you? You can move the post to another one without redoing the plan.",
  '¿Tienes una fecha especial este mes (lanzamiento, promoción, aniversario)? Cuéntamela con «Pedir un cambio» y la incluyo.':
    'Do you have a special date this month (a launch, a sale, an anniversary)? Tell me with "Ask for a change" and I will include it.',
  // textos
  'Lee el texto en voz alta. Si no suena como hablas tú, pídeme el cambio con tus palabras.':
    "Read the text out loud. If it doesn't sound like you, ask me for the change in your own words.",
  'La primera frase es la que hace que alguien se detenga. Si no te da curiosidad a ti, tampoco a ellos.':
    "The first line is what makes someone stop scrolling. If it doesn't make you curious, it won't make them curious either.",
  '¿Ves algo entre corchetes, como [TU PRECIO]? Es un dato que solo tú sabes: complétalo antes de aprobar.':
    'See something in brackets, like [YOUR PRICE]? Only you know that detail: fill it in before approving.',
  // disenos
  'Míralos en tu celular, que es donde los verán tus clientes.': 'Look at them on your phone, which is where your customers will see them.',
  'Si no te gusta un diseño, dime qué cambiarías («más claro», «otra foto»). No tienes que saber de diseño.':
    'If you don\'t like a design, tell me what you would change ("lighter", "another photo"). You don\'t need to know design.',
  'En los carruseles, la primera lámina es la portada: tiene que dar ganas de deslizar.':
    'In carousels, the first slide is the cover: it has to make people want to swipe.',
  // videos
  'Los primeros 3 segundos deciden si te ven. Revisa que el comienzo dé curiosidad.':
    'The first 3 seconds decide whether people keep watching. Make sure the opening sparks curiosity.',
  'Antes de grabar te muestro las escenas en imagen: si alguna no te gusta, cámbiala ahí y ahorras créditos.':
    "Before recording I show you each scene as an image: if you don't like one, change it there and save credits.",
  'Puedes cambiar los textos y los subtítulos del video sin volver a grabarlo.': "You can change the video's text and subtitles without recording it again.",
  // publicar
  'Conecta tus redes una sola vez y yo publico a la hora que elegiste.': 'Connect your networks once and I will post at the time you chose.',
  'Las mejores horas dependen de tu público. Empieza con las que te propongo y las ajustamos según tus resultados.':
    'The best times depend on your audience. Start with the ones I suggest and we will adjust them based on your results.',
  '¿Cambiaste de idea? Puedes mover una publicación a otro día antes de que salga.': 'Changed your mind? You can move a post to another day before it goes out.',
  // medicion
  'Mira la tendencia del mes, no un solo post: un mal día no dice nada.': "Look at the month's trend, not a single post: one bad day means nothing.",
  'Guardados y compartidos pesan más que los «me gusta»: dicen que tu contenido le sirvió a alguien.':
    'Saves and shares matter more than likes: they mean your content helped someone.',
  'Anota qué funcionó mejor este mes y pídeme más de eso cuando armemos el plan del siguiente.':
    'Note what worked best this month and ask me for more of it when we build next month\'s plan.',
  // pantallas/pasos/inicio.tsx (inicio nuevo)
  'tu marca completa': 'your brand fully set up',
  'el mes completo': 'the whole month',
  '{lista} y {n} pasos más': '{lista} and {n} more steps',
  'Hasta el momento ya tienes {tienes}, pero aún nos faltan {faltan} para que tus publicaciones estén listas.':
    'So far you have {tienes}, but we still need {faltan} before your posts are ready.',
  'Hasta el momento ya tienes {tienes}, pero aún nos falta {faltan} para que tus publicaciones estén listas.':
    'So far you have {tienes}, but we still need {faltan} before your posts are ready.',
  'Tu marca y tu mes están completos. Solo falta programar tus publicaciones.': 'Your brand and your month are complete. All that is left is scheduling your posts.',
  'Empecemos por conocer tu negocio. Con eso armo tu estrategia y tus publicaciones del mes.':
    "Let's start by getting to know your business. With that I build your strategy and this month's posts.",
  'Falta el video': 'Video missing',
  'Falta el diseño': 'Design missing',
  'Programar tu mes': 'Schedule your month',
  'Falta: {faltan}': 'Missing: {faltan}',
  'Lista para publicar': 'Ready to post',
  'Aún no hay plan para este mes': 'No plan for this month yet',
  'Ir al plan del mes': 'Go to the monthly plan',
  'Lo que viene': 'Coming up',
  '{listas} de {total} listas este mes': '{listas} of {total} ready this month',
  'No hay más publicaciones este mes.': 'No more posts this month.',
  'Sin límite': 'Unlimited',
  créditos: 'credits',
  'Alcanzan para unas {imagenes} imágenes, {carruseles} carruseles o {reels} reels.':
    'Enough for about {imagenes} images, {carruseles} carousels or {reels} reels.',
  Lista: 'Ready',
  // componentes/completar.tsx y pasos/negocio.tsx (Lo que conocemos)
  'Escribe tu respuesta': 'Type your answer',
  Guardar: 'Save',
  'Ayúdame a completar': 'Help me fill in the gaps',
  'No lo sé todavía': "I don't know yet",
  '¡Gracias! Ya no tengo dudas.': 'Thanks! No more questions.',
  'Actualizo esto con lo que me contaste. No te cuesta créditos.': "I'll update this with what you told me. It costs no credits.",
  'Actualizar con mis respuestas': 'Update with my answers',
  'Faltan {n} de {total}': '{n} of {total} left',
  'Supuse esto: ¿es correcto?': 'I assumed this. Is it right?',
  Otra: 'Other',
  'Sí, es correcto': "Yes, that's right",
  'No, te corrijo': 'No, let me correct it',
  Después: 'Later',
  'Lo que nos confirmaste': 'What you confirmed',
  'Ver los {n}': 'See all {n}',
  'Por completar': 'To fill in',
  'Le hablas de': 'You address them as',
  '¿Te cuento cómo funciona?': 'Want me to show you how it works?',
  '¿Le cuento cómo funciona?': 'May I show you how it works?',
  '¿Querés que te cuente cómo funciona?': 'Want me to show you how it works?',
  'Así suena {marca}': 'This is how {marca} sounds',
  'Le habla de {trato} · emojis: {emojis}': 'Addresses people as {trato} · emojis: {emojis}',
  'Así nunca': 'Never like this',
  // pasos/estrategia.tsx (estilo 3D)
  'Dónde está y cuándo compra': 'Where they are and when they buy',
  'Así lo diría tu cliente': 'How your customer would say it',
  'Tengo 1 duda sobre {que}': 'I have 1 question about {que}',
  'Tengo {n} dudas sobre {que}': 'I have {n} questions about {que}',
  esto: 'this',
  Responder: 'Answer',
  'tu estrategia': 'your strategy',
  'Partes de tu estrategia': 'Parts of your strategy',
  Anterior: 'Previous',
  '{n} de {total}': '{n} of {total}',
  Siguiente: 'Next',
  'del mes': 'of the month',
  '{n} % de tus publicaciones': '{n}% of your posts',
  'Ideas de publicaciones': 'Post ideas',
  // pasos/redes.tsx (vista única)
  'Lo que te funciona': 'What works for you',
  Diagnóstico: 'Diagnosis',
  Recomendaciones: 'Recommendations',
  'Más datos': 'More data',
  'Días sin publicar': 'Days without posting',
  'Ver el resumen completo': 'See the full summary',
  'Partes de tu diagnóstico': 'Parts of your diagnosis',
  'Lo que más te funciona: {formato}': 'What works best for you: {formato}',
  'No usas hashtags.': "You don't use hashtags.",
  'Revisamos {n} publicaciones.': 'We reviewed {n} posts.',
  // pasos/identidad.tsx (vista única)
  'Letras y orden': 'Fonts and layout',
  'Qué cambiamos': 'What we change',
  'Tus colores y letras salen de tu manual de identidad.': 'Your colors and fonts come from your brand guidelines.',
  'Partes de tu identidad': 'Parts of your identity',
  'Tus versiones': 'Your versions',
  // Tipografías y fotos de ejemplo (pasos/identidad.tsx)
  'Grosor de los titulares': 'Heading weight',
  'Sube la fuente en formato TTF, OTF, WOFF o WOFF2.': 'Upload the font as TTF, OTF, WOFF or WOFF2.',
  'La fuente pesa más de 5 MB.': 'The font is larger than 5 MB.',
  'Sugerida por IGOR': 'Suggested by IGOR',
  'Elegida por ti': 'Chosen by you',
  'Tu fuente': 'Your font',
  Titulares: 'Headings',
  'Así se leen los textos de tus publicaciones, con acentos y eñes.': 'This is how the text of your posts reads, with every accent.',
  Cambiar: 'Change',
  'Volver a la sugerida': 'Back to the suggested one',
  'Elige la letra de tus titulares': 'Choose the font for your headings',
  'Elige la letra de tus textos': 'Choose the font for your body text',
  '¿Tienes tu propia tipografía?': 'Do you have your own font?',
  'Confirmo que tengo la licencia de esta tipografía para usarla en las publicaciones y los videos de mi marca, incluido su uso comercial en redes sociales.':
    'I confirm that I hold a license for this font to use it in my brand\'s posts and videos, including commercial use on social media.',
  'Subir mi fuente': 'Upload my font',
  'TTF, OTF, WOFF o WOFF2, hasta 5 MB. Se usa en tus diseños y tus reels.': 'TTF, OTF, WOFF or WOFF2, up to 5 MB. It is used in your designs and reels.',
  'Estoy haciendo 3 fotos con tu estilo…': "I'm making 3 photos in your style…",
  '¿Quieres ver cómo se verían tus fotos?': 'Want to see what your photos would look like?',
  'Hago 3 fotos de ejemplo con tu estilo, tu luz y tus colores: una persona, un detalle y un ambiente.':
    'I make 3 example photos with your style, light and colors: a person, a detail and a setting.',
  'Ver ejemplos de mis fotos': 'See examples of my photos',
  'Usa {n} créditos. Si alguna no sale, no se cobra.': "Uses {n} credits. If one doesn't come out, you aren't charged.",
  'Ejemplo de foto de tu marca': 'Example photo for your brand',
  'Hacer otras 3 ({n} créditos)': 'Make 3 more ({n} credits)',
  'Textos y párrafos': 'Body text',
  // pasos/presentador.tsx (salas)
  'Tus salas de video': 'Your video studios',
  'Estudio de animación': 'Animation studio',
  'Para videos con alguien hablando: UGC y producto.': 'For videos with someone talking: UGC and product.',
  'Para piezas sin presentador, contadas desde el copy.': 'For pieces without a presenter, told from the copy.',
  'Identidad fijada': 'Identity locked',
  Candidata: 'Candidate',
  'Tipografía y gráficos animados': 'Animated type and graphics',
  'Tus frases, íconos y formas de marca en movimiento.': 'Your lines, icons and brand shapes in motion.',
  'Carruseles animados': 'Animated carousels',
  'Cada lámina de tu carrusel se mueve y sale como video.': 'Each slide of your carousel moves and becomes a video.',
  'Historias 9:16': '9:16 Stories',
  'Historias animadas para tu día a día.': 'Animated stories for your day to day.',
  'Comerciales con IA': 'AI commercials',
  'Escenas generadas desde tu copy, con voz en off y música.': 'Scenes generated from your copy, with voice-over and music.',
  'Estoy armando tu estudio de animación': "I'm building your animation studio",
  'Aquí harás piezas que cuentan la idea de tu copy sin que nadie salga en cámara. IGOR te sugerirá cuáles hacer así en tu plan del mes, con su costo en créditos.':
    "Here you'll make pieces that tell your copy's idea without anyone on camera. IGOR will suggest which ones to make this way in your monthly plan, with their credit cost.",
  'Tu equipo': 'Your team',
  // animacion/animador.tsx
  'Este navegador no puede preparar el video. Ábrelo en Chrome desde un computador.': "This browser can't prepare the video. Open it in Chrome on a computer.",
  'No pudimos preparar el video. Vuelve a intentarlo.': "We couldn't prepare the video. Please try again.",
  'Animar pieza': 'Animate post',
  'Animar esta pieza': 'Animate this post',
  'Sin costo: se anima con tus colores y tus letras y se descarga en MP4.': 'Free: animated with your colors and fonts, downloaded as MP4.',
  'Carrusel animado': 'Animated carousel',
  'Tipografía animada · 9:16': 'Animated type · 9:16',
  'Cargando tus letras…': 'Loading your fonts…',
  'Preparando… {n} %': 'Preparing… {n}%',
  'Descargar MP4': 'Download MP4',
  Animar: 'Animate',
  'Tu estudio de animación': 'Your animation studio',
  'Ya disponible, gratis: en Diseños toca «Animar»': 'Available now, free: tap "Animate" in Designs',
  'Muy pronto': 'Coming soon',
  // Tipos de pieza (mes.tsx) e historias
  'Tus historias': "Your stories",
  'Historia': "Story",
  'Primero escribe sus textos': "Write its text first",
  'historia': "story",
  '¿Cómo quieres tus piezas?': "How do you want your posts?",
  'Volver a la propuesta de IGOR': "Back to IGOR's suggestion",
  'Propuesta de IGOR': "IGOR's suggestion",
  'Elige antes de que escriba las ideas: así no gastas créditos en formatos que no quieres.': "Choose before I write the ideas, so you don't spend credits on formats you don't want.",
  'créd.': "cred.",
  'Menos': "Less",
  'Más': "More",
  '{n} publicaciones': "{n} posts",
  'créditos en el mes': "credits this month",
  'Tienes {n}': "You have {n}",
  'El plan de ideas cuesta {n} créditos; lo demás se cobra cuando haces cada paso, nunca antes.': "The ideas plan costs {n} credits; the rest is charged when you do each step, never before.",
  'Elige al menos 4 publicaciones.': "Choose at least 4 posts.",
  'La animas gratis en Diseños, en «Tus historias».': "Animate it for free in Designs, under \"Your stories\".",
  'Un diseño con tu marca.': "A design with your brand.",
  'Varias láminas que enseñan. Se anima gratis.': "Several slides that teach. Animated for free.",
  'Reel con tu presentadora': "Reel with your presenter",
  'Tu presentadora de IA habla a cámara.': "Your AI presenter talks to camera.",
  'Reel con voz en off': "Voice-over reel",
  'Escenas de tu producto o proceso con narración.': "Scenes of your product or process with narration.",
  'Reel animado': "Animated reel",
  'Tipografía y gráficos en movimiento, sin personas.': "Moving type and graphics, no people.",
  'Reel que grabas tú': "Reel you record",
  'Te damos el guion y lo grabas con tu celular.': "We give you the script and you record it on your phone.",
  'Rápida, del día a día, animada gratis.': "Quick, everyday, animated for free.",
  'Comercial con IA': "AI commercial",
  'Una historia animada con escenas de IA y voz en off.': "An animated story with AI scenes and voice-over.",
  'Estilo de tu comercial': "Your commercial style",
  'Las escenas se dibujan en este estilo con los colores de tu marca. Si lo cambias después, se vuelven a dibujar.': "Scenes are drawn in this style with your brand colors. If you change it later, they are drawn again.",
  'Dibujo 2D': "2D drawing",
  'Realista': "Realistic",
  'Plastilina': "Claymation",
  'Anime': "Anime",
  '3D': "3D",
  'Estándar': "Standard",
  'Premium': "Premium",
  'Muy buena animación en 3D, anime o realista por muy pocos créditos.': "Very good 3D, anime or realistic animation for very few credits.",
  'En movimientos grandes el personaje puede cambiar un poco (orejas, manchas).': "In big movements the character can change a little (ears, spots).",
  'Usa bastantes más créditos que la estándar.': "Uses quite a few more credits than standard.",
  'El personaje se mantiene idéntico en toda la escena y el movimiento es muy natural. La mejor para 3D y plastilina.': "The character stays identical through the scene and the motion is very natural. Best for 3D and claymation.",
  'La más fiel a los dibujos 2D y al anime: respeta el trazo sin volverlo 3D.': "The most faithful to 2D drawings and anime: keeps the line art without turning it 3D.",
  "Estudio": "Studio",
  "Comerciales y cortos sin nadie en cámara: IGOR escribe el libreto, crea el reparto y dibuja cada plano antes de animarlo.": "Commercials and short films with nobody on camera: IGOR writes the script, creates the cast and draws every shot before animating it.",
  "Tus producciones": "Your productions",
  "Tu elenco": "Your cast",
  "Nueva producción": "New production",
  "Tu primer comercial empieza con una idea": "Your first commercial starts with an idea",
  "Cuéntale a IGOR qué quieres contar (o usa el copy de una pieza del mes) y él dirige el resto. Ves el storyboard antes de pagar la animación.": "Tell IGOR what you want to say (or use the copy of a post from this month) and he directs the rest. You see the storyboard before paying for the animation.",
  "Dirigir mi primer comercial": "Direct my first commercial",
  "Animar gratis una pieza del mes": "Animate a post of the month for free",
  "Sin título": "Untitled",
  "{n} planos": "{n} shots",
  "En {fase}": "In {fase}",
  "Los personajes, lugares y productos de tu marca, con su hoja de referencia. Se crean una vez y salen iguales en todos tus videos.": "Your brand's characters, places and products, with their reference sheet. Created once, they look the same in all your videos.",
  "Todavía no tienes {tipo}. Créalos aquí o deja que IGOR los proponga al dirigir un comercial.": "You don't have {tipo} yet. Create them here or let IGOR propose them when directing a commercial.",
  "Ver la hoja de {nombre}": "See {nombre}'s sheet",
  "Otra versión · {n} créditos": "Another version · {n} credits",
  "¿Borrar a {nombre} de tu elenco?": "Delete {nombre} from your cast?",
  "Nuevo: {tipo}": "New: {tipo}",
  "Descríbelo": "Describe it",
  "Sube una imagen": "Upload an image",
  "Igor": "Igor",
  "La tienda": "The shop",
  "Mi producto": "My product",
  "JPG, PNG o WEBP · máximo 5 MB": "JPG, PNG or WEBP · 5 MB max",
  "¿Algo que deba saber?": "Anything I should know?",
  "¿Cómo es?": "What is it like?",
  "Un perrito azul de juguete, orejas caídas, bufanda amarilla, curioso y torpe": "A blue toy puppy with floppy ears and a yellow scarf, curious and clumsy",
  "Una panadería de barrio al amanecer, madera clara, vitrinas con pan, luz cálida por la ventana": "A neighborhood bakery at dawn, light wood, bread display cases, warm light through the window",
  "Un frasco de vidrio ámbar con tapa negra y etiqueta blanca": "An amber glass jar with a black lid and a white label",
  "Es mi producto con vida (le ponemos ojos y brazos)": "It's my product brought to life (we add eyes and arms)",
  "Tengo derecho a usar esta imagen y, si sale una persona real, tengo su autorización.": "I have the right to use this image and, if a real person appears, I have their permission.",
  "Subiendo…": "Uploading…",
  "Crear con su hoja · {n} créditos": "Create with its sheet · {n} credits",
  "No te alcanzan los créditos para empezar.": "You don't have enough credits to start.",
  "Volver al estudio": "Back to the studio",
  "¿Qué quieres hacer?": "What do you want to make?",
  "Tu historia": "Your story",
  "Usar el copy de una pieza del mes…": "Use the copy of a post from this month…",
  "Cuenta la idea con tus palabras. Ej.: un repartidor corre contra el reloj por la ciudad y llega justo a tiempo con nuestro pan recién hecho.": "Tell the idea in your own words. E.g.: a courier races against the clock across the city and arrives just in time with our fresh bread.",
  "Si lo dejas vacío, IGOR propone la historia desde tu marca.": "If you leave it empty, IGOR proposes the story from your brand.",
  "Estilo visual": "Visual style",
  "Duración": "Length",
  "Quién sale y dónde": "Who's in it and where",
  "hasta 4, opcional": "up to 4, optional",
  "Aún no tienes elenco: IGOR creará el protagonista y el lugar, y los guardará para tus próximos videos.": "You don't have a cast yet: IGOR will create the lead and the place, and save them for your next videos.",
  "¿Cómo quieres trabajar?": "How do you want to work?",
  "Guíame": "Guide me",
  "Te enseño cada paso (libreto, reparto, planos) y tú apruebas antes de gastar en el siguiente.": "I show you each step (script, cast, shots) and you approve before spending on the next one.",
  "Hazlo tú": "Do it for me",
  "IGOR lo hace todo seguido hasta el video. Luego puedes rehacer planos sueltos.": "IGOR does everything in one go up to the video. Then you can redo single shots.",
  "Tu presupuesto": "Your budget",
  "Muy buena calidad al mejor precio.": "Very good quality at the best price.",
  "Movimiento más fino y el personaje más estable.": "Finer motion and a more stable character.",
  "Libreto y storyboard": "Script and storyboard",
  "Reparto nuevo": "New cast",
  "Imágenes de los planos": "Shot images",
  "Animación": "Animation",
  "Montaje con voz": "Edit with voice-over",
  "Ahora solo se cobran los {n} créditos del libreto. Cada paso te dice su costo antes.": "Only the {n} script credits are charged now. Each step tells you its cost first.",
  "Se cobra paso a paso, sin pasar de este total.": "It's charged step by step, never above this total.",
  "Tu saldo ({n}) no alcanza para todo el video.": "Your balance ({n}) isn't enough for the whole video.",
  "Dirigir mi corto": "Direct my short film",
  "Dirigir mi comercial": "Direct my commercial",
  "En cola…": "Queued…",
  "No te alcanzan los créditos para este paso.": "You don't have enough credits for this step.",
  "IGOR está escribiendo el libreto…": "IGOR is writing the script…",
  "Rehacer el libreto": "Redo the script",
  "Crear el reparto": "Create the cast",
  "Dibujar los planos": "Draw the shots",
  "Animar los planos": "Animate the shots",
  "Montar el video con voz": "Edit the video with voice-over",
  "Primero fijo cómo se ven: una hoja de referencia por personaje, lugar y objeto. Así no cambian entre planos.": "First I lock how they look: one reference sheet per character, place and object. That way they don't change between shots.",
  "Dibujo el primer instante de cada plano con el reparto. Revisa las imágenes: animar cuesta más.": "I draw the first moment of each shot with the cast. Check the images: animating costs more.",
  "Cada imagen aprobada se anima con su movimiento de cámara. Si un plano no te gusta, se rehace solo ese.": "Each approved image is animated with its camera move. If you don't like a shot, only that one is redone.",
  "Uno los planos y les pongo la voz en off.": "I join the shots and add the voice-over.",
  "Texto final": "Final text",
  "Nuevo": "New",
  "¡Tu video está listo!": "Your video is ready!",
  "Con voz en off. Puedes rehacer cualquier plano y volver a montarlo.": "With voice-over. You can redo any shot and edit it again.",
  "Sin voz en off. Puedes rehacer cualquier plano y volver a montarlo.": "Without voice-over. You can redo any shot and edit it again.",
  "Storyboard": "Storyboard",
  "planos": "shots",
  "Salen": "Featuring",
  "en": "in",
  "Otra imagen · {n}": "Another image · {n}",
  "Otra animación · {n}": "Another animation · {n}",
  "¿Cambiamos algo del libreto?": "Shall we change something in the script?",
  "Ej.: que el final sea más emotivo, o que el plano 3 pase de noche.": "E.g.: make the ending more emotional, or set shot 3 at night.",
  "Pedir un cambio · {n} créditos": "Ask for a change · {n} credits",
  "Rehacer el libreto borra las imágenes de los planos que ya estén hechas.": "Redoing the script deletes the shot images already made.",
  "¿Borrar esta producción?": "Delete this production?",
  "Borrar esta producción": "Delete this production",
  "Cine realista": "Realistic cinema",
  "Acción hiperrealista": "Hyper-realistic action",
  "Tipo película animada": "Animated-movie look",
  "Trazo plano": "Flat line art",
  "Estilo japonés": "Japanese style",
  "Stop motion": "Stop motion",
  "Foto de producto": "Product photo",
  "Realista y suave": "Realistic and soft",
  "Personaje": "Character",
  "Personajes": "Characters",
  "Lugar": "Place",
  "Lugares": "Places",
  "Objeto o producto": "Object or product",
  "Objetos": "Objects",
  "Gran general": "Extreme wide",
  "General": "Wide",
  "Medio": "Medium",
  "Medio corto": "Medium close-up",
  "Primer plano": "Close-up",
  "Detalle": "Detail",
  "Normal": "Eye level",
  "Picado": "High angle",
  "Contrapicado": "Low angle",
  "Cenital": "Overhead",
  "Holandés": "Dutch angle",
  "Subjetivo": "POV",
  "A ras de suelo": "Ground level",
  "Fijo": "Static",
  "Acercamiento": "Push in",
  "Alejamiento": "Pull out",
  "Travelling": "Tracking",
  "Seguimiento": "Follow",
  "Paneo": "Pan",
  "Barrido rápido": "Whip pan",
  "Grúa": "Crane",
  "Órbita": "Orbit",
  "Cámara en mano": "Handheld",
  "Dron": "Drone",
  "Libreto": "Script",
  "Reparto": "Cast",
  "Planos": "Shots",
  "Video": "Video",
  "Comercial de producto": "Product ad",
  "Tu producto como protagonista: gancho visual, el producto en acción y cierre con tu marca.": "Your product as the hero: a visual hook, the product in action and a close with your brand.",
  "Cortometraje": "Short film",
  "Una historia con personajes, conflicto y un final que conecta con tu marca.": "A story with characters, conflict and an ending that connects with your brand.",
  "Anuncio de marca": "Brand ad",
  "La personalidad de tu marca en movimiento, con tu logo al final.": "Your brand's personality in motion, with your logo at the end.",
  "Videoclip": "Music video",
  "Planos al ritmo de una canción.": "Shots to the beat of a song.",
  "Tráiler": "Trailer",
  "Suspenso, escalada y un golpe final con tu oferta.": "Suspense, escalation and a final punch with your offer.",
  "Explicativo": "Explainer",
  "Explica tu servicio en tres pasos claros.": "Explain your service in three clear steps.",
  "Anuncio UGC": "UGC ad",
  "Una persona recomendando tu producto a cámara (lo haces en la sala de presentadores).": "A person recommending your product to camera (made in the presenters room).",
  "Contenido social": "Social content",
  "Clips cortos con giro y final en bucle.": "Short clips with a twist and a looping ending.",
  "Microdrama": "Micro drama",
  "Episodios cortos con el mismo reparto y un gancho al final.": "Short episodes with the same cast and a hook at the end.",
  "Luz": "Light",
  "Nombre": "Name",
  "Estilo": "Style",
  "Cerrar": "Close",
  "opcional": "optional",
  "Grabo la voz del narrador, pongo los sonidos de cada plano y la música. Luego lo ves y lo descargas.": "I record the narrator's voice, add each shot's sounds and the music. Then you watch it and download it.",
  "Este video se montó con la versión anterior": "This video was edited with the previous version",
  "Vuelve a montarlo para sumarle música, sonidos de cada plano y una voz natural.": "Edit it again to add music, sound for each shot and a natural voice.",
  "Montar de nuevo · {n} créditos": "Edit again · {n} credits",
  "La voz del narrador": "The narrator's voice",
  "Voz de {nombre}": "Voice by {nombre}",
  "Sin voz en off": "No voice-over",
  "con música": "with music",
  "sin música": "no music",
  "y sonidos en cada plano": "and sound in every shot",
  "Si un plano no te gusta, rehazlo abajo y vuelve a montar: el resto se conserva.": "If you don't like a shot, redo it below and edit again: the rest is kept.",
  "Cambiar la voz": "Change the voice",
  "Editar": "Edit",
  "Notas de carácter": "Character notes",
  "curioso, torpe, entrañable": "curious, clumsy, lovable",
  "¿Qué hay que corregir de cómo se ve?": "What needs fixing in how it looks?",
  "Ej.: es un hombre, no una mujer; tiene barba corta y camisa azul.": "E.g.: it's a man, not a woman; he has a short beard and a blue shirt.",
  "Corregir y redibujar · {n} créditos": "Fix and redraw · {n} credits",
  "Los planos ya dibujados no cambian: rehazlos después si salía en ellos.": "Shots already drawn don't change: redo them afterwards if it appeared in them.",
  "Este paso suele tardar {tiempo}.": "This step usually takes {tiempo}.",
  "Puedes salir de esta pantalla: IGOR sigue trabajando y lo verás aquí al volver.": "You can leave this screen: IGOR keeps working and you'll see it here when you come back.",
  "Tus personajes": "Your characters",
  "opcional, pero ayuda mucho": "optional, but it helps a lot",
  "Di cómo es cada uno: hombre o mujer, edad, cómo se ve y cómo se viste. Así IGOR no tiene que adivinar.": "Say what each one is like: man or woman, age, looks and clothes. That way IGOR doesn't have to guess.",
  "Ej.: hombre de 35 años, barba corta, gafas redondas, suéter mostaza y jeans.": "E.g.: 35-year-old man, short beard, round glasses, mustard sweater and jeans.",
  "Agregar un personaje": "Add a character",
  "Todo el video, de la idea al MP4, tarda entre 15 y 25 minutos. Puedes salir y volver: IGOR sigue trabajando.": "The whole video, from idea to MP4, takes 15 to 25 minutes. You can leave and come back: IGOR keeps working.",
  "Revisé la continuidad entre planos: {n} ajustes": "I checked continuity between shots: {n} fixes",
  "Lo que dice el narrador": "What the narrator says",
  "Guardar la voz · gratis": "Save the voice · free",
  "¿Qué cambio en esta escena?": "What should change in this scene?",
  "Ej.: que se quite las gafas antes de frotarse los ojos; que lleve zapatos.": "E.g.: have him take off his glasses before rubbing his eyes; he should wear shoes.",
  "Corregir la escena {n} · {c} créditos": "Fix scene {n} · {c} credits",
  "Se vuelve a dibujar; después anima de nuevo ese plano y vuelve a montar.": "It gets redrawn; then animate that shot again and edit again.",
  "Quitar": "Remove",
  "1 a 2 minutos": "1 to 2 minutes",
  "2 a 4 minutos": "2 to 4 minutes",
  "3 a 6 minutos": "3 to 6 minutes",
  "8 a 15 minutos": "8 to 15 minutes",
  "1 a 3 minutos": "1 to 3 minutes",
  "alrededor de 1 minuto": "about 1 minute",
  "Ep. {n}": "Ep. {n}",
  "La canción pesa más de 20 MB.": "The song is larger than 20 MB.",
  "No pudimos leer esa canción. Prueba con un MP3, WAV o M4A.": "We couldn't read that song. Try an MP3, WAV or M4A.",
  "Con tu presentadora": "With your presenter",
  "Tu canción": "Your song",
  "Sube la canción o el jingle (MP3, WAV o M4A, hasta 20 MB). IGOR mide el ritmo y corta cada plano en un tiempo fuerte. Usa solo música que tengas derecho a publicar.": "Upload the song or jingle (MP3, WAV or M4A, up to 20 MB). IGOR measures the beat and cuts each shot on a strong beat. Only use music you have the right to publish.",
  "Midiendo el ritmo…": "Measuring the beat…",
  "Elegir la canción": "Choose the song",
  "Cada plano dura {s} s · el video usa {total} s de la canción": "Each shot lasts {s} s · the video uses {total} s of the song",
  "Desde qué segundo empieza": "Starting second",
  "Tu serie": "Your series",
  "Episodio {n} de «{serie}». IGOR continúa desde el gancho del episodio anterior, con el mismo reparto.": "Episode {n} of «{serie}». IGOR picks up from the previous episode's cliffhanger, with the same cast.",
  "Nombre de la serie": "Series name",
  "Ej.: Crónicas de la oficina": "E.g.: Office Chronicles",
  "Empezar otra serie": "Start another series",
  "Sube la canción para dirigir el videoclip.": "Upload the song to direct the music video.",
  "Episodio {n}": "Episode {n}",
  "¿Seguimos la serie?": "Shall we continue the series?",
  "El episodio {n} arranca donde quedó este gancho, con el mismo reparto.": "Episode {n} starts where this cliffhanger left off, with the same cast.",
  "Siguiente episodio": "Next episode",
  "Dirigir mi anuncio de marca": "Direct my brand ad",
  "Dirigir mi videoclip": "Direct my music video",
  "Dirigir mi tráiler": "Direct my trailer",
  "Dirigir mi explicativo": "Direct my explainer",
  "Dirigir mi clip": "Direct my clip",
  "Dirigir el episodio": "Direct the episode",
  "La personalidad de tu marca en movimiento: atmósfera, valores y tu logo al final.": "Your brand's personality in motion: atmosphere, values and your logo at the end.",
  "Subes tu canción o jingle y los planos cortan al ritmo.": "Upload your song or jingle and the shots cut to the beat.",
  "Suspenso, escalada y un golpe final con el título y tu oferta.": "Suspense, escalation and a final punch with the title and your offer.",
  "Explica tu servicio en pasos claros, con escenas y tarjetas de cada paso.": "Explain your service in clear steps, with scenes and a card for each step.",
  "Tu presentadora recomienda tu producto a cámara, como grabada con el celular.": "Your presenter recommends your product to camera, as if filmed with a phone.",
  "Un clip corto para redes: gancho en el primer segundo, giro y final que engancha en bucle.": "A short clip for social media: a hook in the first second, a twist and a looping ending.",
  "Una serie de episodios cortos con el mismo reparto. Cada uno termina en un gancho.": "A series of short episodes with the same cast. Each one ends on a cliffhanger.",
  "Tu cronograma y tus textos están listos. Ahora a producir las piezas.": "Your schedule and your copy are ready. Now let's produce the pieces.",
  "Ir a producción": "Go to production",
  "Diseño gráfico": "Graphic design",
  "Tus historias, carruseles y publicaciones del mes, con tu estilo.": "Your stories, carousels and posts for the month, in your style.",
  "Volver a Video": "Back to Video",
  "Cronograma": "Schedule",
  "Qué se publica cada día, en qué formato y en qué redes.": "What gets published each day, in which format and on which networks.",
  "Las personas que hablan a cámara en tus reels. Puedes tener hasta tres en tu equipo.": "The people who speak to camera in your reels. You can have up to three on your team.",
  "tu video": "your video",
  "¿Te gusta la historia de «{nombre}»?": "Do you like the story of «{nombre}»?",
  "Revisarla toma un minuto": "Reviewing it takes a minute",
  "Revisar": "Review",
  "¿Te gustan las escenas de «{nombre}»?": "Do you like the scenes of «{nombre}»?",
  "Es el último paso antes de animarlo": "It's the last step before animating it",
  "Falta montar «{nombre}»": "«{nombre}» still needs editing",
  "Voz, sonidos y música": "Voice, sound and music",
  "Montar": "Edit",
  "Empieza el video del {dia}": "Start the video for {dia}",
  "Graba el reel del {dia}": "Record the reel for {dia}",
  "Grabar": "Record",
  "Tu estudio audiovisual. Arriba lo que te toca; abajo, todo lo demás.": "Your audiovisual studio. What's up next at the top; everything else below.",
  "Te toca": "Up next",
  "Después: {siguiente}": "After that: {siguiente}",
  "Tus videos están al día": "Your videos are up to date",
  "Cuando haya algo que revisar, aparece aquí.": "When there's something to review, it shows up here.",
  "Crear un video": "Create a video",
  "Reel, comercial, corto, tráiler…": "Reel, ad, short film, trailer…",
  "Las personas que hablan a cámara": "The people who speak to camera",
  "Personajes y lugares": "Characters and places",
  "Personajes, ambientes, productos y objetos": "Characters, settings, products and objects",
  "Storyboards": "Storyboards",
  "{n} videos y cómo van": "{n} videos and how they're going",
  "Quién sale en tus historias y dónde pasan. Se crean una vez y salen iguales en todos tus videos.": "Who appears in your stories and where they happen. Created once, they look the same in all your videos.",
  "Tus videos y en qué paso va cada uno.": "Your videos and which step each one is on.",
  "Ver los reels del mes con presentadora": "See this month's presenter reels",
  "¿Qué video quieres hacer?": "What video do you want to make?",
  "Elige uno. Después solo cuentas la idea; IGOR sugiere el resto.": "Pick one. Then just tell the idea; IGOR suggests the rest.",
  "Reel con presentadora": "Presenter reel",
  "Una persona de tu equipo le habla a cámara": "Someone on your team speaks to camera",
  "Reels de tu mes": "Your month's reels",
  "Los guiones de tu parrilla, dichos a cámara por tu presentadora": "The scripts in your calendar, said to camera by your presenter",
  "Reels con presentadora": "Presenter reels",
  "Los reels del mes donde alguien de tu equipo le habla a cámara. Tú eliges con qué calidad se hacen.": "This month's reels where someone on your team speaks to camera. You choose the quality.",
  "Producción": "Production",
  "Programación y publicación": "Scheduling and publishing",
  "Ambiente": "Setting",
  "Ambientes": "Settings",
  "Objeto": "Object",
  "Copiar el texto": "Copy the text",
  "Descargar {n}": "Download {n}",
  "El comercial del mes se hace en el Estudio.": "This month's ad is made in the Studio.",
  "El video quedó guardado en su día. Prográmalo desde Programación y publicación.": "The video was saved on its day. Schedule it from Scheduling and publishing.",
  "En LinkedIn se publica a mano: te lo dejamos listo en «Para publicar a mano».": "LinkedIn is published by hand: we leave it ready in «To publish by hand».",
  "Este mes no hay reels con presentadora en tu plan.": "There are no presenter reels in this month's plan.",
  "Este mes todavía no tiene cronograma. Ármalo en Tu mes y vuelve aquí para programarlo.": "This month doesn't have a schedule yet. Build it in Your month and come back to schedule it.",
  "Hoy": "Today",
  "Ir a Video": "Go to Video",
  "LinkedIn castiga lo programado. El día que toca, copias el texto, descargas el archivo y lo publicas tú.": "LinkedIn penalizes scheduled posts. On the day, copy the text, download the file and post it yourself.",
  "LinkedIn · a mano": "LinkedIn · by hand",
  "Listo: quedó programado. Lo ves en Programación y publicación.": "Done: it's scheduled. You'll see it in Scheduling and publishing.",
  "Los {n} comerciales del mes se hacen en el Estudio.": "This month's {n} ads are made in the Studio.",
  "Nunca te pedimos la contraseña de tu red. LinkedIn no se conecta: castiga lo programado, así que sus piezas te las dejamos listas para publicar a mano.": "We never ask for your network's password. LinkedIn isn't connected: it penalizes scheduled posts, so we leave its pieces ready to publish by hand.",
  "Para publicar a mano en LinkedIn": "To publish by hand on LinkedIn",
  "Primero elige quién sale en tus reels, en la sala de presentadores.": "First choose who appears in your reels, in the presenters room.",
  "Programar en mi mes": "Schedule in my month",
  "Programar para el {dia}": "Schedule for {dia}",
  "Su cara todavía no está fijada. Puedes hacer los videos igual, pero el rostro cambiará un poco de uno a otro. Fijarla cuesta 1 crédito y se hace en la sala de presentadores.": "Their face isn't locked yet. You can still make the videos, but the face will change a bit between them. Locking it costs 1 credit and is done in the presenters room.",
  "Tus redes conectadas y lo que sale cada día. Arrastra una pieza para cambiarla de día.": "Your connected networks and what goes out each day. Drag a piece to move it to another day.",
  "¿Cuándo sale este video?": "When does this video go out?",
  "Algunas no salieron. IGOR las vuelve a dibujar.": "Some didn't come out. IGOR draws them again.",
  "Carrusel · {n} láminas": "Carousel · {n} slides",
  "Crear {mes}": "Create {mes}",
  "Dejarla así": "Leave it as is",
  "Diseña las piezas del mes": "Design this month's pieces",
  "Falta montar el video": "The video still needs editing",
  "Faltan algunas escenas": "Some scenes are missing",
  "IGOR graba la voz, pone los sonidos y la música y lo monta.": "IGOR records the voice, adds the sound and music, and edits it.",
  "Ir a Diseño gráfico": "Go to Graphic design",
  "Ir a Programación y publicación": "Go to Scheduling and publishing",
  "Montar el video": "Edit the video",
  "Rehacer esta pieza": "Redo this piece",
  "Revisa tus diseños": "Review your designs",
  "Si te gusta, IGOR crea lo que falte de tus personajes y lugares y dibuja cada escena. Tarda unos minutos.": "If you like it, IGOR creates any missing characters and places and draws each scene. It takes a few minutes.",
  "Si te gustan, IGOR las anima, graba la voz, pone los sonidos y la música, y monta el video. Tarda entre 10 y 20 minutos.": "If you like them, IGOR animates them, records the voice, adds sound and music, and edits the video. It takes 10 to 20 minutes.",
  "Sí, anima y monta el video": "Yes, animate and edit the video",
  "Sí, dibuja las escenas": "Yes, draw the scenes",
  "Te falta revisar 1 diseño.": "You have 1 design left to review.",
  "Te faltan {n} diseños por revisar.": "You have {n} designs left to review.",
  "Terminar las escenas": "Finish the scenes",
  "Todo quedó aprobado.": "Everything is approved.",
  "Tus diseños del mes están listos": "Your designs for the month are ready",
  "Tus historias, carruseles y publicaciones, con tu estilo.": "Your stories, carousels and posts, in your style.",
  "Tus textos del mes están listos": "Your copy for the month is ready",
  "Ver todas": "See all",
  "Volver a revisar una por una": "Back to reviewing one by one",
  "{n} de {total} listas": "{n} of {total} ready",
  "¿Qué le cambiamos a esta pieza?": "What should we change in this piece?",
  "¿Te gusta la historia?": "Do you like the story?",
  "¿Te gustan las escenas?": "Do you like the scenes?",
  "Sube el plan de Supabase antes de que se llene: si se llena, la app deja de guardar.": "Upgrade the Supabase plan before it fills up: when full, the app stops saving.",
  "Se dibuja después": "Drawn later",
  "Corregir el logo · {n} créditos": "Fix the logo · {n} credits",
  "Usar mi logo real · gratis": "Use my real logo · free",
  "Usar mi captura real · gratis": "Use my real screenshot · free",
  "Tu logo real": "Your real logo",
  "Tu video muestra tu logo": "Your video shows your logo",
  "Para que se vean de verdad (y no inventados), sube tus capturas de pantalla o tu logo reales. Se guardan en Tu identidad y sirven para todos tus videos.": "So they look real (not made up), upload your real screenshots or logo. They're saved in Your identity and used in all your videos.",
  "Tu logo (PNG con fondo transparente, si lo tienes)": "Your logo (PNG with transparent background, if you have it)",
  "¿Alguna no te convence? Toca «Rehacer» en su tarjeta, abajo.": "Not happy with one? Tap «Redo» on its card below.",
  "✓ Para rehacer": "✓ To redo",
  "Rehacer": "Redo",
  "Rehacer la imagen de la escena {lista}": "Redo the image of scene {lista}",
  "Rehacer las imágenes de las escenas {lista}": "Redo the images of scenes {lista}",
  "Se dibujan de nuevo; las de ahora quedan guardadas como versión anterior por si quieres volver.": "They're drawn again; the current ones are kept as a previous version in case you want to go back.",
  "Las que ya estaban animadas habrá que animarlas otra vez.": "The ones already animated will need animating again.",
  "Rehacer · {n} créditos": "Redo · {n} credits",
  "¿Que arranque justo donde terminó el plano {n}?": "Start right where shot {n} ended?",
  "Toma la última imagen de la animación del plano anterior y la usa como inicio de este: misma gente, misma posición, misma luz. Gratis; después anima este plano.": "Takes the last image of the previous shot's animation and uses it as this shot's start: same people, same position, same light. Free; then animate this shot.",
  "Tomando la imagen…": "Taking the image…",
  "Empezar donde terminó el plano {n}": "Start where shot {n} ended",
  "los personajes": "the characters",
  "¿Qué falló en la animación?": "What went wrong in the animation?",
  "¿Qué falló en la imagen?": "What went wrong in the image?",
  "IGOR la anima otra vez pidiendo que las caras y la ropa queden idénticas a la imagen.": "IGOR animates it again asking for faces and clothes identical to the image.",
  "IGOR la corrige partiendo de la imagen actual para que cada uno sea igual a su hoja.": "IGOR fixes it from the current image so everyone matches their sheet.",
  "¿Qué debía hacer? Ej.: que tome el teléfono con la mano derecha y sonría al leer.": "What should it do? E.g.: pick up the phone with the right hand and smile while reading.",
  "Ya salió raro antes: esta vez IGOR reescribe el plano más simple en vez de repetirlo igual.": "It came out wrong before: this time IGOR rewrites the shot simpler instead of repeating it.",
  "A veces la IA falla una vez: se hace otra versión igual.": "Sometimes the AI fails once: another identical version is made.",
  "Arreglarlo": "Fix it",
  "No se parece": "Doesn't look like them",
  "Hace otra cosa": "Does something else",
  "El encuadre": "The framing",
  "Salió raro una vez": "Came out weird once",
  "Tu captura real": "Your real screenshot",
  "Equipo de cámara": "Equipment",
  "Faltan unos {n} minutos.": "About {n} minutes left.",
  "Ya casi termina.": "Almost done.",
  "Está tardando más de lo normal, pero sigue trabajando.": "It's taking longer than usual, but it's still working.",
  "Avísame cuando termine": "Notify me when it's done",
  "Te aviso con una notificación cuando termine, aunque estés en otra pestaña.": "I'll send you a notification when it's done, even if you're on another tab.",
  "Tarjetas": "Cards",
  "Lista de planos": "Shot list",
  "Narrador": "Narrator",
  "Cambia la cámara de cada plano aquí mismo, gratis. Si el plano ya está dibujado, el tamaño, la perspectiva y el lente se aplican al volver a dibujarlo; el movimiento, el equipo y la duración, al animarlo.": "Change each shot's camera right here, for free. If the shot is already drawn, size, perspective and lens apply when it's redrawn; movement, equipment and duration, when it's animated.",
  "Descargar la lista (CSV)": "Download the list (CSV)",
  "Abrir la escena para corregirla": "Open the scene to fix it",
  "Escena": "Scene",
  "Plano": "Shot",
  "Encabezado": "Scene heading",
  "Diálogo": "Dialogue",
  "Descripción": "Shot description",
  "Tamaño": "Shot size",
  "Perspectiva": "Perspective",
  "Movimiento": "Movement",
  "Equipo": "Equipment",
  "Lente": "Focal length",
  "Formato": "Aspect ratio",
  "Notas": "Notes",
  "Gran plano general": "Extreme wide",
  "Plano de situación": "Establishing",
  "Plano entero": "Full shot",
  "Medio largo": "Medium long",
  "Primerísimo primer plano": "Extreme close-up",
  "A la altura de los ojos": "Eye-level",
  "A la rodilla": "Knee-level",
  "Al hombro": "Shoulder-level",
  "Aéreo": "Aerial",
  "Sobre el hombro": "Over the shoulder",
  "Desde atrás": "From behind",
  "Trípode": "Tripod",
  "En mano": "Handheld",
  "Steadicam": "Steadicam",
  "Gimbal": "Gimbal",
  "Slider": "Slider",
  "DÍA": "DAY",
  "NOCHE": "NIGHT",
  "ATARDECER": "SUNSET",
  "AMANECER": "DAWN",
  "Versión anterior": "Previous version",
  "Versión siguiente": "Next version",
  "Usar esta versión": "Use this version",
  "Esta es la que se usa": "This is the one in use",
  "Cada imagen debe pesar menos de 5 MB.": "Each image must be under 5 MB.",
  "¿Tienes una foto de lo que quieres (un objeto, una prenda, una pose)? Súbela y IGOR la usa de referencia. Hasta 3.": "Do you have a photo of what you want (an object, a garment, a pose)? Upload it and IGOR uses it as a reference. Up to 3.",
  "Agregar una referencia": "Add a reference",
  "¿Qué pasa justo después?": "What happens right after?",
  "Agregar el siguiente momento": "Add the next moment",
  "Ya tienes 8 planos, el máximo.": "You already have 8 shots, the maximum.",
  "IGOR crea un plano nuevo después de este, partiendo de su imagen: la misma gente, el mismo lugar y la misma luz. Solo cambia lo que escribas.": "IGOR creates a new shot after this one, starting from its image: the same people, place and light. Only what you write changes.",
  "Ej.: primer plano de su cara sonriendo al ver el celular; o: Camila se levanta y camina hacia la ventana.": "E.g.: close-up of her face smiling at the phone; or: Camila gets up and walks to the window.",
  "Crear el siguiente momento · {n} créditos": "Create the next moment · {n} credits",
  "Después anímalo y vuelve a montar el video.": "Then animate it and edit the video again.",
  "Cómo se anima": "How it's animated",
  "termina en el plano siguiente": "ends on the next shot",
  "Cambiar cómo se anima": "Change how it's animated",
  "Movimiento de la cámara": "Camera movement",
  "Lo que dice {quien}": "What {quien} says",
  "Terminar justo donde empieza el plano siguiente (los une sin salto)": "End exactly where the next shot begins (joins them without a jump)",
  "Se guarda gratis y se usa la próxima vez que animes este plano.": "It's saved for free and used the next time you animate this shot.",
  "Dibujarla de cero (si no, parte de la imagen actual y cambia solo lo que pides)": "Draw it from scratch (otherwise it starts from the current image and changes only what you ask)",
  "Su historia": "Their story",
  "Su historia y ambiente": "Its story and atmosphere",
  "Quién es, de dónde viene, cómo se comporta, qué quiere. Ej.: dueña de un salón de belleza en Medellín; perfeccionista, habla rápido y se ríe fuerte; quiere que su negocio crezca sin perder a sus clientas de siempre.": "Who they are, where they come from, how they behave, what they want. E.g.: owns a beauty salon in Medellín; a perfectionist who talks fast and laughs loudly; wants her business to grow without losing her regular clients.",
  "Ej.: un salón pequeño de barrio, lleno de fotos de clientas y luz de neón morada.": "E.g.: a small neighborhood salon, full of client photos and purple neon light.",
  "¿Así queda tu historia?": "Is this your story?",
  "Reescribiste escenas: IGOR rehace los planos para que cuenten tu historia tal cual. Después la vuelves a revisar.": "You rewrote scenes: IGOR remakes the shots so they tell your story exactly. Then you review it again.",
  "Rehacer el storyboard con mi historia": "Remake the storyboard with my story",
  "Si te gusta, IGOR crea a cada personaje y lugar con su hoja: todos sus ángulos, sus expresiones y su historia. Después los revisas antes de dibujar las escenas.": "If you like it, IGOR creates each character and place with its sheet: all its angles, expressions and story. Then you review them before the scenes are drawn.",
  "Sí, crea los personajes": "Yes, create the characters",
  "Si te gusta, IGOR dibuja cada escena con tus personajes. Tarda unos minutos.": "If you like it, IGOR draws each scene with your characters. It takes a few minutes.",
  "¿Te gustan tus personajes?": "Do you like your characters?",
  "Mira a cada uno con su hoja y su historia. Si alguno no es como lo imaginas, corrígelo o pide otra versión antes de dibujar: así sale igual en todas las escenas.": "Look at each one with their sheet and story. If one isn't how you imagined, fix it or ask for another version before drawing: that way they look the same in every scene.",
  "La historia": "The story",
  "Léela como un guion. Si algo no es como lo imaginas, escríbelo aquí: quién está, qué hace, qué dice. Cambiar el texto es gratis.": "Read it like a script. If something isn't how you imagined, write it here: who is there, what they do, what they say. Changing the text is free.",
  "Guardar la escena": "Save the scene",
  "Deshacer": "Undo",
  "Tu idea o guion": "Your idea or script",
  "Escríbela como la tienes en la cabeza: quién sale y cómo es, dónde pasa, qué pasa en cada escena, qué se dice y cómo termina. Puede ser una frase o un guion completo; lo que no escribas, IGOR lo propone.": "Write it the way you picture it: who appears and what they look like, where it happens, what happens in each scene, what is said and how it ends. It can be one sentence or a full script; whatever you leave out, IGOR proposes.",
  "Ej.: Camila, 30 años, dueña de una panadería, abre a las 5 a. m. Escena 1: amasa sola, cansada. Escena 2: le llega un pedido grande por el celular. Escena 3: sonríe, mete las bandejas al horno. Termina con el pan saliendo dorado y el texto «Hecho hoy, para ti».": "E.g.: Camila, 30, owns a bakery and opens at 5 a.m. Scene 1: she kneads alone, tired. Scene 2: a big order arrives on her phone. Scene 3: she smiles and slides the trays into the oven. It ends with golden bread coming out and the text «Baked today, for you».",
  "Escribirla por partes": "Write it in parts",
  "se dice": "said",
  "texto en pantalla": "on-screen text",
  "Idea": "Idea",
  "Quién sale (y cómo es)": "Who appears (and what they look like)",
  "Dónde pasa": "Where it happens",
  "Escena 1": "Scene 1",
  "Escena 2": "Scene 2",
  "Escena 3": "Scene 3",
  "Lo que se dice": "What is said",
  "Cómo termina": "How it ends",
  "¿Quién lo presenta?": "Who presents it?",
  "Habla a cámara con su cara y su voz de siempre. Entre lo que dice, IGOR muestra tu producto en uso.": "They talk to camera with their usual face and voice. Between their lines, IGOR shows your product in use.",
  "Su cara todavía no está fijada: fíjala en la sala (1 crédito) para que se vea igual en todos los planos.": "Their face isn't locked yet: lock it in the room (1 credit) so it looks the same in every shot.",
  "Primero elige a tu presentadora en la sala de presentadores.": "First choose your presenter in the presenters room.",
  "Ir a la sala": "Go to the room",
  "Pulir los planos": "Polish the shots",
  "Cerrar el pulido": "Close polishing",
  "¿Un plano arranca con un salto, termina con una mano rara o va en cámara lenta? Arréglalo aquí sin volver a generarlo. Gratis y al instante.": "Does a shot start with a jump, end with a weird hand or play in slow motion? Fix it here without generating it again. Free and instant.",
  "{n} s": "{n} s",
  "Nada": "None",
  "Plano {n}": "Shot {n}",
  "Verlo": "Watch it",
  "Dejarlo como estaba": "Reset it",
  "Quitar del inicio": "Trim the start",
  "Quitar del final": "Trim the end",
  "Velocidad": "Speed",
  "Acercar": "Zoom in",
  "No": "No",
  "Un poco": "A little",
  "Tapa letras falsas o bordes raros.": "Hides fake letters or odd edges.",
  "¿Algo del movimiento no quedó bien?": "Something off in the motion?",
  "Dime qué corregir y IGOR vuelve a animar este plano desde la misma imagen: la cara, la ropa y el lugar no cambian.": "Tell me what to fix and IGOR animates this shot again from the same image: the face, clothes and place don't change.",
  "Ej.: que la mano no se deforme al tomar el teléfono; la cámara se acerca más despacio.": "E.g.: the hand shouldn't warp when picking up the phone; the camera moves in more slowly.",
  "Rehacer la animación · {n}": "Redo the animation · {n}",
  "Falta animar el plano {lista}": "Shot {lista} still needs animating",
  "Faltan por animar los planos {lista}": "Shots {lista} still need animating",
  "IGOR los anima partiendo de la misma escena aprobada (si un modelo no puede, prueba con otro sin perder la continuidad) y monta el video.": "IGOR animates them from the same approved scene (if one model can't, it tries another without losing continuity) and edits the video.",
  "Animar los que faltan": "Animate the missing ones",
  "Esta escena todavía no tiene animación": "This scene isn't animated yet",
  "Animar este plano · {n}": "Animate this shot · {n}",
  "Escenas": "Scenes",
  "¿Qué debe sentir quien lo ve?": "What should viewers feel?",
  "Es el alma del video: manda sobre la música, la voz, la luz y el ritmo.": "It is the soul of the video: it drives the music, voice, light and pace.",
  "Melancólico": "Melancholic",
  "Emotivo y tierno": "Moving and tender",
  "Tenso": "Tense",
  "Épico": "Epic",
  "Alegre": "Cheerful",
  "Divertido": "Funny",
  "Inspirador": "Inspiring",
  "Tus personajes elegidos están hechos en otro estilo: el video se hará en el estilo de ellos para que no cambien de cara.": "Your chosen characters were made in another style: the video will use their style so their faces don't change.",
  "1 a 4 minutos": "1 to 4 minutes",
  "Falta revisar la continuidad": "Continuity check pending",
  "IGOR mira todas las escenas juntas, como se verán seguidas, y repinta las que no encajen (otra cara, otro lugar, otra ropa).": "IGOR looks at all the scenes together, as they will play in a row, and repaints the ones that don't fit (another face, place or outfit).",
  "Revisar la continuidad": "Check continuity",
  "Revisión de continuidad de las escenas": "Scene continuity check",
  "4 a 12 minutos": "4 to 12 minutes",
  "Voz: {nombre}": "Voice: {nombre}",
  "La voz de @{nombre} (suena igual en todos tus videos)": "@{nombre}'s voice (sounds the same in all your videos)",
  "Quién habla en tu video": "Who speaks in your video",
  "Cada personaje tiene su voz y el narrador la suya: nunca se confunden. Escúchalas y cámbialas antes de animar.": "Each character has their own voice and the narrator has theirs: they never get mixed up. Listen and change them before animating.",
  "Cada captura puede pesar hasta 5 MB.": "Each screenshot can be up to 5 MB.",
  "Tu video muestra tu producto digital en pantalla": "Your video shows your digital product on screen",
  "Para que se vea tu app o tu web de verdad (y no una inventada), sube capturas de pantalla reales. Se guardan en Tu identidad y sirven para todos tus videos.": "So your real app or website shows up (not an invented one), upload real screenshots. They're saved in Your identity and used in all your videos.",
  "Capturas de tu app en el celular (1 a 4)": "Screenshots of your mobile app (1 to 4)",
  "Capturas de tu web en el computador (1 a 4)": "Screenshots of your website on desktop (1 to 4)",
  "No tengo capturas: que IGOR imagine la pantalla": "I don't have screenshots: let IGOR imagine the screen",
  "Tu app o web": "Your app or website",
  "Tu app en el celular": "Your app on mobile",
  "Tu web en el computador": "Your website on desktop",
  "Capturas reales: se ven tal cual en las pantallas de tus videos y diseños, en lugar de una interfaz inventada.": "Real screenshots: they appear as-is on the screens in your videos and designs, instead of an invented interface.",
  "Captura": "Screenshot",
  "Quitar esta captura": "Remove this screenshot",
  "Agregar capturas": "Add screenshots",
  "Escribiendo la historia": "Writing the story",
  "Historia por revisar": "Story to review",
  "Escenas por aprobar": "Scenes to approve",
  "Falta montar": "Needs editing",
  "«{nombre}» está listo: guárdalo en tu mes": "«{nombre}» is ready: save it to your month",
  "Así queda en su día de la parrilla": "So it lands on its day in the plan",
  "En tu parrilla": "In your plan",
  "Listo, falta guardarlo": "Ready, not saved yet",
  "En producción": "In production",
  "Sin empezar": "Not started",
  "Videos del mes": "Videos this month",
  "{n} de {total} en tu parrilla": "{n} of {total} in your plan",
  "Video listo, guárdalo": "Video ready, save it",
  "Guardado en tu parrilla, en su día: {dia}.": "Saved in your plan, on its day: {dia}.",
  "Guardado en tu parrilla.": "Saved in your plan.",
  "Guardar en mi mes": "Save to my month",
  "1 marca incluida": "1 brand included",
  "Agendar horas con tu equipo": "Book hours with your team",
  "Anual · 2 meses gratis": "Yearly · 2 months free",
  "Aprobación de tus clientes": "Client approval",
  "Cambiar a {plan}": "Switch to {plan}",
  "Cancelado: activo hasta el {fecha}": "Canceled: active until {fecha}",
  "Cerrar sesión": "Sign out",
  "Con tu correo o con Google. Sin contraseñas.": "With your email or Google. No passwords.",
  "Crea tu cuenta": "Create your account",
  "Crea tu cuenta gratis": "Create your free account",
  "Crear mi cuenta": "Create my account",
  "Crear mi cuenta con Google": "Create my account with Google",
  "Créditos sin límite": "Unlimited credits",
  "Desde {n} USD, en cualquier plan. Duran un año y se usan después de los de tu plan.": "From {n} USD, on any plan. They last a year and are used after your plan credits.",
  "El mínimo es {n} USD.": "The minimum is {n} USD.",
  "Elegir {plan}": "Choose {plan}",
  "Empiezas con créditos gratis para armar tu marca y tu mes. Sin tarjeta.": "You start with free credits to build your brand and your month. No card.",
  "Entra aquí": "Sign in here",
  "Entrar con Google": "Sign in with Google",
  "Estrategia, mes, textos y diseños con IA": "Strategy, month plan, copy and AI designs",
  "Estudio de video": "Video studio",
  "Guardado.": "Saved.",
  "Llamada mensual de estrategia": "Monthly strategy call",
  "Marca blanca": "White label",
  "Mensual": "Monthly",
  "Mi perfil": "My profile",
  "Mis marcas": "My brands",
  "Otro monto": "Other amount",
  "Planes": "Plans",
  "Presentadores con IA": "AI presenters",
  "Quiero recibir consejos y novedades de IGOR": "I want tips and news from IGOR",
  "Recargar créditos": "Top up credits",
  "Recargar {usd} USD": "Top up {usd} USD",
  "Reporte mensual descargable": "Downloadable monthly report",
  "Revisión de {n} competidores": "Review of {n} competitors",
  "Tu WhatsApp": "Your WhatsApp",
  "Tu negocio": "Your business",
  "Tu nombre": "Your name",
  "Tu perfil": "Your profile",
  "Tus datos": "Your details",
  "Video premium de cine": "Premium cinematic video",
  "Ya tengo cuenta": "I have an account",
  "año": "year",
  "o": "or",
  "{n} créditos al mes": "{n} credits a month",
  "{n} créditos disponibles": "{n} credits available",
  "{n} h al mes de equipo humano, agendadas en calendario": "{n} h a month of human team, booked on a calendar",
  "{n} marcas incluidas": "{n} brands included",
  "{n} usuarios": "{n} users",
  "{n} vencen el {fecha}": "{n} expire on {fecha}",
  "{usd} USD = {n} créditos": "{usd} USD = {n} credits",
  "¿Más marcas? Suma las que quieras por {n} créditos al mes cada una, en cualquier plan.": "More brands? Add as many as you want for {n} credits a month each, on any plan.",
  "¿Primera vez?": "First time?",
  "¿Ya tienes cuenta?": "Already have an account?",
  "Últimos movimientos": "Recent activity",
  "{mensaje}\n\n¿Sumar «{nombre}» por {n} créditos al mes? Se descuentan de tus créditos cada mes; si no alcanzan, la marca queda en pausa sin perder nada.": "{mensaje}\n\nAdd «{nombre}» for {n} credits a month? They are deducted from your credits each month; if they run short, the brand is paused without losing anything.",
  "Soporte por correo": "Email support",
  "Soporte por WhatsApp": "WhatsApp support",
  "Soporte prioritario por WhatsApp": "Priority WhatsApp support",
  "WhatsApp directo con tu equipo": "Direct WhatsApp with your team",
  'unos {n} minutos': 'about {n} minutes',
  'entre {a} y {b} minutos': '{a} to {b} minutes',
  'Suele tardar {tiempo}.': 'It usually takes {tiempo}.',
  'Llevas': 'Elapsed',
  'Cuánto toma cada parte': 'How long each part takes',
  'Tu marca': 'Your brand',
  'Tu mes': 'Your month',
  'Diseños': 'Designs',
  'Un video del Estudio': 'A Studio video',
  "Agregar más": "Add more",
  "Armemos tu estrategia": "Let's build your strategy",
  "Arrastra aquí o toca para elegir": "Drag here or tap to choose",
  "Colores, letras y tres logos para elegir": "Colors, fonts and three logos to choose from",
  "Como se lo contarías a un amigo.": "As you'd tell a friend.",
  "Créala tú, IGOR": "Create it for me, IGOR",
  "Cómo le hablamos a tus clientes": "How we talk to your customers",
  "Empecemos por lo básico.": "Let's start with the basics.",
  "Lo subo con lo que me gusta": "I'll upload it with what I like",
  "Los temas de cada mes": "The topics for each month",
  "Los ángulos que más venden": "The angles that sell best",
  "Opcional, pero ayuda mucho: lo leo entero y no te pregunto lo que ya diga ahí.": "Optional, but it helps a lot: I read it all and won't ask what's already there.",
  "PNG con fondo transparente si lo tienes · 5 MB cada uno": "PNG with transparent background if you have it · 5 MB each",
  "Posts, anuncios o marcas que te inspiren": "Posts, ads or brands that inspire you",
  "Quién te compra y por qué": "Who buys from you and why",
  "Si lo dejas vacío, te propongo algunos": "Leave it empty and I'll suggest some",
  "Si tu marca tiene manual, de ahí saco tus colores, tus letras y cómo se usa tu logo · PDF hasta 20 MB": "If your brand has a guide, I'll take your colors, fonts and logo usage from it · PDF up to 20 MB",
  "Sube al menos un diseño que te guste para seguir.": "Upload at least one design you like to continue.",
  "Sus dolores, miedos y deseos, en sus palabras": "Their pains, fears and desires, in their words",
  "Te propongo nombre, logo y colores": "I'll suggest a name, logo and colors",
  "Tengo nombre y quizá redes": "I have a name and maybe social media",
  "Tu brief o la historia de tu marca": "Your brief or your brand story",
  "Tu logo y lo que te gusta": "Your logo and what you like",
  "Tu negocio en tus palabras": "Your business in your words",
  "Tus colores, tus letras y tu logo: así se verán todos tus diseños.": "Your colors, fonts and logo: this is how all your designs will look.",
  "Una presentación, un brief o tu plan de negocio · hasta 20 MB": "A deck, a brief or your business plan · up to 20 MB",
  "Uso la versión del logo que corresponda según el fondo de cada diseño.": "I use the right logo version for each design's background.",
  "Ya tengo logo": "I already have a logo",
  "tunegocio": "yourbusiness",
  "¿Ya tienes logo?": "Do you already have a logo?",
  "Tú": "Tú",
  "Usted": "Usted",
  "Vos": "Vos",
  "Capturas de tu app en el celular": "Screenshots of your app on the phone",
  "Capturas de tu web en el computador": "Screenshots of your website on the computer",
  "PNG con fondo transparente, si lo tienes": "PNG with transparent background, if you have it",
  "de 1 a 4": "1 to 4",
  "Cada imagen, hasta 5 MB": "Each image, up to 5 MB",
  "Usar este logo": "Use this logo",
  "Usar estas {n} capturas": "Use these {n} screenshots",
  "Te habla tu presentadora": "Your presenter talks to camera",
  "Lo grabas tú": "You record it",
  "Textos que se mueven": "Moving text",
  "Una historia con escenas": "A story with scenes",
  "Varias láminas que enseñan algo.": "Several slides that teach something.",
  "Rápida, del día a día. Se anima gratis.": "Quick, everyday. Animated for free.",
  "Una persona de IA le habla a cámara. Se hace en la Sala de presentadores.": "An AI person talks to camera. Made in the Presenter room.",
  "Te damos el guion y la portada; lo grabas con tu celular.": "We give you the script and cover; you record it with your phone.",
  "Frases y gráficos de tu marca en movimiento, sin personas. Se anima gratis en Diseño gráfico.": "Your brand's phrases and graphics in motion, no people. Animated for free in Graphic design.",
  "Personajes y lugares hechos con IA, escena por escena. Se dirige en el Estudio.": "AI-made characters and places, scene by scene. Directed in the Studio.",
  "Publicaciones": "Posts",
  "≈ {a} a {b} créditos en el mes": "≈ {a} to {b} credits this month",
  "≈ {n} créditos en el mes": "≈ {n} credits this month",
  "Incluye el plan de ideas ({n} créditos). Lo demás se cobra cuando haces cada paso, nunca antes; las historias con escenas dependen de cuántas escenas tenga el video.": "Includes the ideas plan ({n} credits). The rest is charged when you do each step, never before; stories with scenes depend on how many scenes the video has.",
  "Grabar con tu presentadora": "Record with your presenter",
  "Ver tu guion": "See your script",
  "Animar en Diseño gráfico": "Animate in Graphic design",
  "Seguir en el Estudio": "Continue in the Studio",
  "Dirigir en el Estudio": "Direct in the Studio",
  "Frases animadas sobre una foto tuya o con tus colores. Se anima gratis.": "Animated phrases over one of your photos or your colors. Animated for free.",
  "Fondo": "Background",
  "Más fotos": "More photos",
  "Sube tus fotos": "Upload your photos",
  "Este video son tus frases en movimiento: se anima aquí, gratis.": "This video is your phrases in motion: animate it here, for free.",
  "Animar el video": "Animate the video",
  "Este video lo grabas tú con el guion de tus textos.": "You record this video with the script from your texts.",
  "Este video lo graba tu presentadora.": "Your presenter records this video.",
  "Este video es una historia con escenas: se dirige en el Estudio.": "This video is a story with scenes: it's directed in the Studio.",
  "Portada de tu video": "Cover of your video",
  "Portada de video": "Video cover",
  "{n} piezas del mes · usa las flechas de tu teclado": "{n} pieces this month · use your keyboard arrows",
  "Piezas del mes": "This month's pieces",
  "Así se verá la portada": "This is how the cover will look",
  "Así se verá publicada": "This is how it will look when posted",
  "Buscar": "Search",
  "Para ti": "For you",
  "Te espera": "Waiting for you",
  "Próximas publicaciones": "Upcoming posts",
  "Videos en producción": "Videos in production",
  "Créditos": "Credits",
  "Cómo te fue": "How it went",
  "Consejo del día": "Tip of the day",
  "Arrastra las tarjetas para ordenarlas y toca el ojo para ocultarlas.": "Drag the cards to reorder them and tap the eye to hide them.",
  "Volver al orden de IGOR": "Back to IGOR's order",
  "Personalizar": "Customize",
  "Arrastrar": "Drag",
  "Mover antes": "Move earlier",
  "Mover después": "Move later",
  "Ocultas": "Hidden",
  "Ver todo": "See all",
  "Todavía no hay plan para este mes.": "There's no plan for this month yet.",
  "Armar el plan": "Build the plan",
  "publicaciones": "posts",
  "Ya pasó todo lo de este mes.": "Everything this month already went out.",
  "Cuando armes tu plan, aquí ves lo que sale.": "Once you build your plan, you'll see what goes out here.",
  "Ver el cronograma": "See the schedule",
  "listos": "done",
  "Aún no hay videos en el Estudio.": "No videos in the Studio yet.",
  "disponibles": "available",
  "Se cobran cuando haces cada paso, nunca antes.": "Charged when you do each step, never before.",
  "seguidores": "followers",
  "vistas": "views",
  "Cuando publiques, aquí ves cómo te va.": "Once you post, you'll see how it's going here.",
  "Ver Métricas": "See Metrics",
  "Atrás": "Back",
  "Continuar": "Continue",
  "Saltar": "Skip",
  "Sin responder": "Not answered",
  "Si todavía es una idea, te propongo nombre, logo y colores.": "If it's still an idea, I'll suggest a name, logo and colors.",
  "Solo la idea": "Just the idea",
  "Sí": "Yes",
  "Nombre y redes": "Name and socials",
  "¿Cómo se llama tu negocio?": "What's your business called?",
  "Si lo dejas vacío, te propongo algunos.": "Leave it empty and I'll suggest some.",
  "Tu Instagram y tu web son opcionales: si los pones, los reviso para entenderte mejor.": "Your Instagram and website are optional: if you add them, I'll check them to understand you better.",
  "Qué vendes": "What you sell",
  "A quién le vendes": "Who you sell to",
  "Qué te hace diferente": "What makes you different",
  "Tu respuesta": "Your answer",
  "Dónde y para qué": "Where and why",
  "¿Dónde estás y qué quieres lograr?": "Where are you and what do you want to achieve?",
  "Todo lo que tengas": "Everything you have",
  "¿Tienes un brief o algo escrito de tu marca?": "Do you have a brief or anything written about your brand?",
  "Ayuda mucho: lo leo entero y no te pregunto lo que ya diga ahí.": "It helps a lot: I read it all and won't ask what's already there.",
  "Texto pegado": "Pasted text",
  "Pégalo aquí": "Paste it here",
  "Idioma y trato": "Language and tone",
  "¿En qué idioma y cómo le hablas a tus clientes?": "In what language and how do you talk to your customers?",
  "Idioma del contenido": "Content language",
  "Revisar y analizar": "Review and analyze",
  "¿Todo bien? Revisa y lo analizo": "All good? Review it and I'll analyze it",
  "Para cambiar algo, toca su paso en la lista.": "To change something, tap its step in the list.",
  "Redes y web": "Socials and website",
  "Dónde estás": "Where you are",
  "Qué quieres lograr": "What you want to achieve",
  "{n} archivos": "{n} files",
  "Si no, IGOR te crea la identidad: colores, letras y tres logos para elegir.": "If not, IGOR creates your identity: colors, fonts and three logos to choose from.",
  "Lo que transmite": "What it conveys",
  "Listo para crear tu identidad": "Ready to create your identity",
  "Archivos del logo": "Logo files",
  "Sube tu logo": "Upload your logo",
  "Las versiones que tengas: uso la que corresponda según el fondo de cada diseño.": "The versions you have: I use the right one for each design's background.",
  "¿Qué diseños te gustan?": "Which designs do you like?",
  "Posts, anuncios o marcas que te inspiren: de ahí saco el estilo.": "Posts, ads or brands that inspire you: I take the style from there.",
  "Manual y notas": "Guide and notes",
  "¿Algo más de tu estilo?": "Anything else about your style?",
  "Si tu marca tiene manual, de ahí saco tus colores, tus letras y cómo se usa tu logo.": "If your brand has a guide, I take your colors, fonts and logo usage from it.",
  "PDF hasta 20 MB": "PDF up to 20 MB",
  "¿Todo bien? Defino tu estilo": "All good? I'll define your style",
  "Manual": "Guide",
  "Notas de estilo": "Style notes",
  "Tus respuestas a «Ayúdame a completar»": "Your answers to \"Help me complete\"",
  "Un video": "A video",
  "Los diseños del mes": "This month's designs",
  "El plan de otro mes": "Another month's plan",
  "Otra marca": "Another brand",
  "Esta semana": "This week",
  "1 publicación": "1 post",
  "Carruseles": "Carousels",
  "Historias": "Stories",
  "Toca una publicación para ver su texto, moverla o programarla.": "Tap a post to see its text, move it or schedule it.",
  "Programadas": "Scheduled",
  "Tu mejor publicación": "Your best post",
  "{n} interacciones": "{n} interactions",
  "Tus publicaciones, de más a menos": "Your posts, from most to least",
  "Lo que más te funcionó": "What worked best",
  "El tema que más gustó": "The favorite topic",
  "Frente a antes de IGOR": "Compared to before IGOR",
  "{ahora} por publicación (antes {antes})": "{ahora} per post (before {antes})",
  "Es el que tienes ahora": "It's the one you have now",
  "{n} de {total} listos": "{n} of {total} done",
  "En curso": "In progress",
  "Pendiente": "Pending",
  "Puedes cerrar la página: IGOR sigue trabajando.": "You can close the page: IGOR keeps working.",
  "Contando tus revisiones. Mientras IGOR trabaja puedes cerrar la página.": "Including your reviews. While IGOR works you can close the page.",
  "Se borra todo: su estrategia, sus meses, textos, diseños, videos y archivos. No se puede deshacer y los créditos usados no se devuelven.": "Everything is deleted: its strategy, months, texts, designs, videos and files. It can't be undone and used credits aren't refunded.",
  "Para confirmar, escribe su nombre: {nombre}": "To confirm, type its name: {nombre}",
  "Borrando…": "Deleting…",
  "Borrar la marca": "Delete the brand",
  "Cancelar": "Cancel",
  'una sola vez': 'only once',
  'min': 'min',
  'a veces hasta {n} min': 'sometimes up to {n} min',
  'casi siempre igual': 'almost always the same',
  'cada mes': 'every month',
  'por tanda': 'per batch',
  'por video': 'per video',
  'La calidad toma su tiempo. Puedes cerrar la página mientras tanto: IGOR sigue trabajando y lo encuentras listo al volver.': "Quality takes time. You can close the page meanwhile: IGOR keeps working and it will be ready when you come back.",
  'Todo el video, de la idea al MP4:': 'The whole video, from idea to MP4:',
  'Puedes salir y volver: IGOR sigue trabajando.': 'You can leave and come back: IGOR keeps working.',
  'Si te gustan, IGOR las anima, graba la voz, pone los sonidos y la música, y monta el video.': 'If you like them, IGOR animates them, records the voice, adds sound and music, and edits the video.',
  // Inicio (01-10-2026): solo lo que te espera.
  'Sigue con {paso}': 'Continue with {paso}',
  'Cuéntame de tu negocio': 'Tell me about your business',
  'paso {n} de {total}': 'step {n} of {total}',
  'Revisa 1 diseño': 'Review 1 design',
  'Revisa {n} diseños': 'Review {n} designs',
  '1 minuto por diseño': '1 minute per design',
  'Elige los días y las redes': 'Choose the days and the networks',
  'Hola, {nombre}.': 'Hi, {nombre}.',
  'Hola.': 'Hi.',
  'Hoy no te espera nada': 'Nothing is waiting for you today',
  'Te espera 1 cosa': '1 thing is waiting for you',
  'Te esperan {n} cosas': '{n} things are waiting for you',
  'Primero armamos tu marca. Después, lo de cada mes va casi solo.': 'First we build your brand. After that, each month runs almost on its own.',
  'Lo demás de {mes} va solo.': 'Everything else in {mes} runs on its own.',
  'Lo demás va solo.': 'Everything else runs on its own.',
  'Solo lo que te espera. Cada tarjeta te lleva directo a donde toca.': 'Only what is waiting for you. Each card takes you straight to the right place.',
  // pantallas/pasos/inicio.tsx (marca nueva: los 4 pasos de Tu marca antes del tablero)
  'Armemos {marca}.': "Let's build {marca}.",
  'Armemos tu marca.': "Let's build your brand.",
  'Son 4 pasos, uno a la vez. Cuando estén listos, aquí verás tu mes y lo que te espera.': "It's 4 steps, one at a time. Once they're done, you'll see your month and what's waiting for you here.",
  'Me cuentas de tu negocio y lo que vendes. Puedes pegar lo que ya tengas.': 'Tell me about your business and what you sell. You can paste whatever you already have.',
  'Con eso armo a quién le hablas, qué decirle y cómo venderle.': 'With that I work out who you talk to, what to say and how to sell to them.',
  'Miro tus redes para saber de dónde partimos. Si no tienes, lo saltas.': "I look at your social accounts to see where we're starting from. If you don't have any, skip it.",
  'Tus colores, letras y logo, para que todo se vea tuyo.': 'Your colors, fonts and logo, so everything looks like yours.',
  'Listo · Ver': 'Done · View',
  'Mientras tanto, un consejo': 'Meanwhile, a tip',
  'Listo, seguir con mi video': 'Done, continue with my video',
  'Volver a mi video': 'Back to my video',
  'Primero, ¿quién sale en tu video?': 'First, who appears in your video?',
  'Tus videos los presenta una persona creada con IA. La eliges una sola vez en la Sala de presentadores y sale en todos.': 'Your videos are presented by a person created with AI. You choose them once in the Presenters room and they appear in all of them.',
  'Elegir quién sale': 'Choose who appears',
  'Al elegirla, te traemos de vuelta aquí.': "Once you choose, we'll bring you back here.",
  'La referencia pesa más de 5 MB. Elige una imagen más liviana.': 'The reference is larger than 5 MB. Choose a lighter image.',
  'Una referencia': 'A reference',
  'Un diseño que te guste: seguimos su estilo con tus colores · 5 MB': 'A design you like: we follow its style with your colors · 5 MB',
  'Con {n} publicaciones tarda entre {a} y {b} minutos; puedes salir y volver.': 'With {n} posts it takes {a} to {b} minutes; you can leave and come back.',
  'Ahora': 'Now',
};
